import { Box, useTheme } from "@seneca/senekit";

import TextPlaceholder from "features/common/components/TextPlaceholder";

export default function LoadingSessions() {
  const themes = useTheme();
  return (
    <Box
      backgroundColor={themes["foreground"]}
      borderRadius="small"
      padding="xlarge"
      display="flex"
      flexDirection="column"
      gap="xlarge"
    >
      {Array.from({ length: 7 }).map(() => (
        <TextPlaceholder
          placeholderHeight="1rem"
          placeholderWidth="100%"
          loading
        />
      ))}
    </Box>
  );
}
